import type { SfToken } from '../SfToken.ts'
import { symbolToStr } from '../utils/symbolToStr.ts'
import { TOKEN } from '../utils/TOKEN.ts'
import { serializeError } from './serializeError.ts'

const TOKEN_REGEX = /^[a-zA-Z*][!#$%&'*+\-.^_`|~\w:/]*$/

// 4.1.7.  Serializing a Token
//
// Given a Token as input_token, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  Convert input_token into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If the first character of input_token is not ALPHA or "*", or the
//     remaining portion contains a character not in tchar, ":" or "/",
//     fail serialization.
//
// 3.  Let output be an empty string.
//
// 4.  Append input_token to output.
//
// 5.  Return output.

/**
 * @internal
 */
export function serializeToken(token: symbol | SfToken): string {
	const value = symbolToStr(token)
	if (TOKEN_REGEX.test(value) === false) {
		throw serializeError(value, TOKEN)
	}
	return value
}
